import { Typography, IconButton } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";

const GoBack = () => {
  const navigate = useNavigate();
  
  return (
    <IconButton
      onClick={() => navigate(-1)}
      sx={{
        mb: 2,
        color: "text.secondary",
        "&:hover": {
          backgroundColor: "rgba(124,58,237,0.1)",
          color: "#7C3AED",
        },
      }}
    >
      <AiOutlineArrowLeft size={20} />
      <Typography
        component="span"
        sx={{
          ml: 1,
          textDecoration: "none",
          color: "inherit",
          fontWeight: 500,
        }}
      >
        Back
      </Typography>
    </IconButton>
  );
};

export default GoBack;
